import type { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { isMobile } from '@/biz/tool';

export default function CreatorPackageBonusBanner({
  amount,
  className = ''
}: {
  amount: number;
  className?: string;
}) {
  const { t } = useTranslation();
  if (!Number.isFinite(amount) || amount <= 0) return null;
  const amountStyle = { '--digits': String(amount).length } as CSSProperties;
  return (
    <div className={`relative h-[90px] w-full overflow-hidden ${className}`}>
      <img
        src="/bonus-tip-bg.png"
        alt=""
        className="absolute left-0 top-0 h-[76px] w-full"
      />
      <div className="absolute bottom-3 left-[15px] right-[15px] flex items-center gap-2">
        <span
          className={`shrink-0 whitespace-nowrap bg-gradient-to-b from-[#7047EB] to-[#D6B7FA] bg-clip-text font-bold leading-normal text-transparent ${
            isMobile()
              ? 'text-[clamp(12px,calc(80px/var(--digits)*1.05),24px)]'
              : 'text-[clamp(18px,calc(128px/var(--digits)*1.05),36px)]'
          }`}
          style={amountStyle}
        >
          {`$${amount}`}
        </span>
        <span className="min-w-0 max-w-[218px] flex-1 text-base font-bold leading-5 text-[#330E81]">
          {t('multi_platform.quote.bonus_copy', {
            defaultValue: 'Earn an extra bonus for delivering on time!'
          })}
        </span>
      </div>
    </div>
  );
}
